import React, { useState } from "react";
import imageCompression from "browser-image-compression";
import JSZip from "jszip";
import { saveAs } from "file-saver";
const ImageCompressor = () => {
  const [compressedImages, setCompressedImages] = useState([]);

  console.log(compressedImages);
  

  const handleImageUpload = async (event) => {
    const files = event.target.files; // User ne jo images select ki hain
    if (!files.length) return;

    let compressedFiles = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const options = {
        maxSizeMB: 1, // Max 1MB
        maxWidthOrHeight: 800, // Max width/height
        useWebWorker: true, // Faster processing
      };

      try {
        const compressedFile = await imageCompression(file, options);
        console.log(i);
        const compressedBlob = new Blob([compressedFile], { type: file.type });
        compressedFiles.push({
          original: URL.createObjectURL(file),
          compressed: URL.createObjectURL(compressedFile),
          name: file.name,
          blob: compressedBlob,
        });
      } catch (error) {
        console.error("Compression failed:", error);
      }
    }

    setCompressedImages(compressedFiles);
  };
  const downloadAllCompressedImages = async () => {
    if (compressedImages.length === 0) return;

    const zip = new JSZip();
    compressedImages.forEach((img) => {
      zip.file(img.name, img.blob); // ZIP file me add karega
    });

    const zipBlob = await zip.generateAsync({ type: "blob" });
    saveAs(zipBlob, "compressed_images.zip"); // ZIP ko download karega
  };
  return (
    <div>
      <h1>Image Compressor</h1>
      <input type="file" multiple accept="image/*" onChange={handleImageUpload} />
     {compressedImages.length > 0 && <button onClick={downloadAllCompressedImages} disabled={compressedImages.length === 0}>
        Download All as ZIP
      </button>}
      <div>
        {compressedImages.map((img, index) => (
          <div key={index} style={{ marginBottom: "20px" }}>
            <p>{img.name}</p>
            <p>Original:</p>
            <img src={img.original} alt="original" width="100" />
            <p>Compressed:</p>
            <img src={img.compressed} alt="compressed" width="100" />
            <a href={img.compressed} download={img.name}>
              Download Compressed
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCompressor;
